module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/yjjy.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fyjjy.png
// module id = 8KAF
// module chunks = 93